<div>
  <h3>Quelles lectures souhaitez-vous annuler ?</h3>
  <mat-checkbox
    *ngIf="input?.reviewer1"
    [formControl]="reviewer1FormControl">
    {{ input?.reviewer1?.firstName }} {{ input?.reviewer1?.lastName }}
  </mat-checkbox>
  <mat-checkbox
    *ngIf="input?.reviewer2"
    [formControl]="reviewer2FormControl">
    {{ input?.reviewer2?.firstName }} {{ input?.reviewer2?.lastName }}
  </mat-checkbox>
</div>
  